import React from "react";
import { connect } from "react-redux";
import GestionarAccesoMovil from "./GestionarAccesoMovil.cmpt";
import GestionarAgregarMovil from "./GestionarAgregarMovil.cmpt";
import GestionarEliminarMovil from "./GestionarEliminarMovil.cmpt";
import InvitacionEnviadaMovil from "./InvitacionEnviadaMovil.cmpt";
import InvitadoEliminadoMovil from "./InvitadoEliminadoMovil.cmpt";

const mapState = (state) => {
	return {
		seccion: state.af.paso
	};
};

class ModalGestionar extends React.Component {
	state = {}

	render() {
		return (
			<div>
				{this.props.modalOpen &&
					<div>
						{ this.props.seccion == 0 &&
							<GestionarAccesoMovil />
						}
						{ this.props.seccion == 1 && 
							<GestionarAgregarMovil />
						}
						{ this.props.seccion == 2 && 
							<GestionarEliminarMovil />
						}
						{ this.props.seccion == 3 && 
							<InvitacionEnviadaMovil />
						}
						{ this.props.seccion == 4 && 
							<InvitadoEliminadoMovil />
						}
					</div>
				}
			</div>
		);
	}
}

export default connect(mapState, null)(ModalGestionar);


// WEBPACK FOOTER //
// ./src/acceso-familiar/modalGestionarMovil.cmpt.js